'use client';

import React from 'react';
import { Users, User } from 'lucide-react';

type Props = {
  value: 'band' | 'solo';
  onChange: (v: 'band' | 'solo') => void;
};

export default function SignUpTypeToggle({ value, onChange }: Props) {
  return (
    <div className="flex gap-3 mb-8">
      <button
        type="button"
        onClick={() => onChange('band')}
        className={`flex-1 flex flex-col items-center gap-2 py-5 px-4 rounded-lg border-2 transition-all duration-200 ${
          value === 'band' ?'border-[#f5c842] bg-[#f5c842]/10 text-[#f5c842]' :'border-[#2a2a2a] bg-[#141414] text-[#888] hover:border-[#444] hover:text-[#f0ece3]'
        }`}
      >
        <Users size={28} strokeWidth={value === 'band' ? 2.5 : 1.5} />
        <span className="font-display text-2xl tracking-wider">BAND</span>
        <span className="text-xs font-medium opacity-70 text-center leading-tight">
          Sign up as a band — one song, one slot
        </span>
      </button>

      <button
        type="button"
        onClick={() => onChange('solo')}
        className={`flex-1 flex flex-col items-center gap-2 py-5 px-4 rounded-lg border-2 transition-all duration-200 ${
          value === 'solo' ?'border-[#e8386d] bg-[#e8386d]/10 text-[#e8386d]' :'border-[#2a2a2a] bg-[#141414] text-[#888] hover:border-[#444] hover:text-[#f0ece3]'
        }`}
      >
        <User size={28} strokeWidth={value === 'solo' ? 2.5 : 1.5} />
        <span className="font-display text-2xl tracking-wider">SOLO MUSICIAN</span>
        <span className="text-xs font-medium opacity-70 text-center leading-tight">
          List your songs — get matched with others
        </span>
      </button>
    </div>
  );
}